import React, { useEffect } from "react";
import { useLanguage } from "../lib/language";
import { translations } from "../lib/translations";

export function AccessibilityStatementPage() {
  const { language } = useLanguage();
  const t = translations;

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

    const timer = setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="prose prose-lg max-w-none">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">
            {t.accessibilityStatementTitle[language]}
          </h1>

          <p className="text-sm text-gray-600 mb-8">
            {t.accessibilityStatementLastUpdated[language]}
          </p>

          <div className="space-y-8">
            <div>
              <p className="text-gray-700 leading-relaxed whitespace-pre-line">
                {t.accessibilityStatementIntro[language]}
              </p>
            </div>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t.accessibilitySection1Title[language]}
              </h2>
              <div className="text-gray-700 leading-relaxed whitespace-pre-line">
                {t.accessibilitySection1Content[language]}
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t.accessibilitySection2Title[language]}
              </h2>
              <div className="text-gray-700 leading-relaxed whitespace-pre-line">
                {t.accessibilitySection2Content[language]}
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t.accessibilitySection3Title[language]}
              </h2>
              <div className="text-gray-700 leading-relaxed whitespace-pre-line">
                {t.accessibilitySection3Content[language]}
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t.accessibilitySection4Title[language]}
              </h2>
              <div className="text-gray-700 leading-relaxed whitespace-pre-line">
                {t.accessibilitySection4Content[language]}
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
